import { useTranslation } from 'react-i18next';

import type { StoreStatus } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

const STYLES: Record<StoreStatus, string> = {
  active: 'bg-success/15 text-success border-transparent dark:bg-success/20',
  draft: 'bg-secondary text-secondary-foreground border-transparent',
  paused: 'bg-warning/20 text-warning-foreground border-transparent dark:text-warning',
  closed: 'border-border text-muted-foreground',
};

export function StoreStatusBadge({
  status,
  className,
}: {
  status: StoreStatus;
  className?: string;
}) {
  const { t } = useTranslation('common');
  return (
    <Badge variant="outline" className={cn(STYLES[status], className)}>
      {t(`status.${status}`)}
    </Badge>
  );
}
